import React from 'react';
import Component from './posts'

function PostLoading(Component) {
    return function PostLoadingComponent({isLoading, ...props }) {
        if (!isLoading) return <Component {...props} />;
        return (
            <p style={{fontSize: '25px'}}>
                We are waiting for the data to load!...
            </p>
        )
    };
}

export default PostLoading;